import Cookies from 'js-cookie'

export const getAuth = () => Cookies.get('auth');
